import { Node } from '@tiptap/core'
import { VueNodeViewRenderer } from '@tiptap/vue-2'
import Component from './Summary.vue'

export default Node.create({
  name: 'HavetDetails',
  group: 'block',
  content: 'block*',

  addAttributes() {
    return {
      title: {
        default: 'Titel',
      },
      id: {
        default: 'title',
      },
      isOpen: {
        default: true,
      },
      class: {
        default:['havet-details'],
        parseHTML: el => {
          const attr = el.getAttribute('class')
          return attr ? attr.split(' ') : null  
        }
      }
    }
  },

  parseHTML() {
    return [
      {
        tag: 'details',
      },
    ]
  },

  renderHTML({HTMLAttributes}) {
    const open = HTMLAttributes.isOpen ? {'open':true} : {}
    const attr = {...HTMLAttributes, class: HTMLAttributes.class.join(' '), ...open }
    return ['details', attr, 0]
  },

  addNodeView() {
    return VueNodeViewRenderer(Component)
  },
})